import WaybillPrinted from '../enum/WaybillPrinted'

const WaybillPrintedNameMap = {
    [WaybillPrinted.ALL]: '所有',

    [WaybillPrinted.PRINTED]: '已打印快递单',

    [WaybillPrinted.UNPRINTED]: '未打印快递单',

}

export default WaybillPrintedNameMap